export default class ContentProduct {

    /**
     * @type {HTMLElement[]}
     */
    element;

    /**
     * @type {HTMLElement[]}
     */
    radios;

    /**
     * @type {HTMLElement[]}
     */
    images;

    /**
     * @type {Object}
     */
    linksData;

    activeClass = 'product-card__gallery-image--active';

    /**
     * @type {'hover'|'click'}
     */
    mode = 'click';

    constructor(element) {
        this.element = element;
        this.element.inited = true;

        this.radios = Array.from(this.element.querySelectorAll('.radio-color [type="radio"]'));
        this.images = Array.from(this.element.querySelectorAll('.product-card__gallery-image'));

        this.addListeners();
        this.findData();
        this.setupGallery();
    }

    addListeners() {
        if (this.mode === 'click') {
            this.radios.forEach(radio => {
                radio.addEventListener('change', () => {
                    this.setupGallery();
                });
            });
            return;
        }

        if (this.mode === 'hover') {
            this.radios.forEach(radio => {
                const label = radio.closest('label');

                label.addEventListener('mouseenter', () => {
                    radio.checked = true;
                    this.setupGallery();
                });
            });
            return;
        }
        
    }

    findData() {
        const scriptEl = this.element.querySelector('[data-gallery-links]');

        if (!scriptEl) {
            return;
        }

        try {
            this.linksData = JSON.parse(scriptEl.textContent);
        } catch(error) {
            console.warn(error);
        }
    }

    setupGallery() {
        const checked = this.radios.find(r => r.checked);

        if (!checked) {
            return;
        }
        
        this.setActive(checked.value);
    }

    setActive(id) {
        this.changeTitleAndLink(id);

        this.images.forEach(img => {
            if (img.dataset.color === id) {
                img.classList.add(this.activeClass);
            } else {
                img.classList.remove(this.activeClass);
            }
        });
    }

    changeTitleAndLink(id) {
        if (!this.linksData) {
            return;
        }

        const item = this.linksData.find(i => i.term === id);

        const {
            title,
            link
        } = item;

        if (!title || !link) {
            return;
        }

        this.element.href = link;

        const titleEl = this.element.querySelector('.product-card__text-content-title');
        const linkEl = this.element.querySelector('[data-link]');

        if (titleEl) {
            titleEl.innerHTML = title;
        }

        if (linkEl) {
            linkEl.href = link;
            linkEl.title = title;
        }
    }
};

(() => {
    Array.from(document.querySelectorAll('.product-card')).forEach(p => {
        if (p.inited) {
            return;
        }

        new ContentProduct(p);
    })
})();
